import { createContext, useContext, useState, useCallback, type ReactNode } from 'react';

interface EnquiryModalContextType {
  openEnquiry: (productName?: string) => void;
  closeEnquiry: () => void;
  productName: string;
  isOpen: boolean;
}

const EnquiryModalContext = createContext<EnquiryModalContextType | null>(null);

export function EnquiryModalProvider({ children }: { children: ReactNode }) {
  const [isOpen, setIsOpen] = useState(false);
  const [productName, setProductName] = useState('');

  const openEnquiry = useCallback((name?: string) => {
    setProductName(name || 'Fresh Fruits & Vegetables Bulk Supply');
    setIsOpen(true);
    document.body.style.overflow = 'hidden';
  }, []);

  const closeEnquiry = useCallback(() => {
    setIsOpen(false);
    document.body.style.overflow = '';
  }, []);

  return (
    <EnquiryModalContext.Provider value={{ openEnquiry, closeEnquiry, productName, isOpen }}>
      {children}
    </EnquiryModalContext.Provider>
  );
}

export function useEnquiryModal() {
  const ctx = useContext(EnquiryModalContext);
  if (!ctx) throw new Error('useEnquiryModal must be used within EnquiryModalProvider');
  return ctx;
}